import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import ErrorBoundary from "./components/common/ErrorBoundary";

import RequireMode from "./components/common/RequireMode";
import { AppModeProvider } from "./context/AppMode";

import Header from "./components/home/Header";
import HomeSelector from "./components/home/HomeSelector";

import CalendarView from "./components/calendar/CalendarView";
import Restricted from "./components/common/Restricted";
import UsersList from "./components/users/UsersList";

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <AppModeProvider>
          <Routes>
            <Route path="/select" element={<HomeSelector />} />

            <Route
              path="/*"
              element={
                <RequireMode>
                  <div className="app">
                    <Header />
                    <Routes>
                      <Route path="calendar" element={<CalendarView />} />
                      <Route
                        path="users"
                        element={
                          <Restricted adminOnly>
                            <UsersList />
                          </Restricted>
                        }
                      />
                    </Routes>
                  </div>
                </RequireMode>
              }
            />
          </Routes>
        </AppModeProvider>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
